<script setup>
import { computed } from "vue";
import amabloxLogo from "../../../assets/brick.png";
import pagixLogo from "../../../assets/pagix.png";
import timebrellaLogo from "../../../assets/timebrella.png";

const appCode = import.meta.env.PUBLIC_APP_CODE ?? 'amablox';

const logoSrc = computed(() => {
    switch (appCode) {
        case "pagix":      return pagixLogo;
        case "timebrella": return timebrellaLogo;
        default:           return amabloxLogo;
    }
});
</script>

<template>
    <span>
        <img :src="logoSrc" class="small-logo img-fluid d-inline-block align-text-center" />
    </span>
</template>
